import { agent, settings } from "~/core/paths";
import { contentPath, type ReadingSlug, readingPath } from "~/modules/analytics/lib/loop";

const DESTINATIONS: Record<string, ReadingSlug> = {
	no_questions: "prompts",
	factcheck_high: "factcheck",
	publishing_review: "progress",
	publishing_attention: "progress",
};

/** The reading a to-do belongs to, where it belongs to one. */
function actionReading(code: string): ReadingSlug | null {
	return DESTINATIONS[code] ?? null;
}

/** And where its button goes. */
export function actionPath(entityId: string, code: string, workflowId?: string): string {
	const base = `/w/${entityId}`;
	// The usual cause of "nobody cited you" is a name we never learned, not an
	// absence — so that one goes to the aliases, not to a chart of zeroes.
	if (code === "not_cited") return settings(entityId, "identity");
	if (code === "few_datapoints") return settings(entityId, "facts");
	if (code === "gaps_open") return contentPath(base, "pending");
	if (code === "pages_review") return contentPath(base, "drafts");
	if (code === "low_credits") return settings(entityId, "subscription");
	if (code === "badge_missing") return `${settings(entityId, "site")}?tab=badge`;
	// The one card that is not about a decision: the run is already going, and
	// the only thing to look at is the run.
	if (code === "sampling_now" || code === "setup_running" || code === "setup_preparing")
		return `${base}/tasks/loop?status=active`;
	if (code === "tasks_failed") return `${base}/tasks/loop?status=failed`;
	// The workflow is the thing that stopped, and the canvas is where its failed
	// step, its Run button and its clock are. A brand with no copy of it at all
	// takes one from the template library on the Agent's home.
	if (code.startsWith("setup_") || code.startsWith("loop_"))
		return agent(entityId, workflowId ? `w/${workflowId}` : "home");
	const reading = actionReading(code);
	return reading ? readingPath(base, reading) : base;
}
